import { useEffect, useMemo } from 'react';
import { marketDataRuntime } from '../../data/client/marketDataRuntime';
import { useIndexUniverse, useQuote } from '../../data/stores/quoteStore';
import { formatNumber, formatPercent } from '../../shared/format';

const INDEX_FIELDS = ['symbol', 'last', 'change', 'changePct', 'time'] as const;

export function IndexPanel() {
  const indexes = useIndexUniverse();
  const symbols = useMemo(() => indexes.map((index) => index.symbol), [indexes]);

  useEffect(() => {
    if (symbols.length === 0) return undefined;
    return marketDataRuntime.subscribeQuotes('sidebar-indexes', symbols, [...INDEX_FIELDS]);
  }, [symbols]);

  if (indexes.length === 0) return null;

  return (
    <section className="index-panel" aria-label="Indexes">
      <h2>Indexes</h2>
      <div className="index-panel__list">
        {indexes.map((index) => <IndexRow key={index.symbol} symbol={index.symbol} name={index.name} />)}
      </div>
    </section>
  );
}

function IndexRow({ symbol, name }: { symbol: string; name: string }) {
  const quote = useQuote(symbol);
  const tone = quote.change > 0 ? 'positive' : quote.change < 0 ? 'negative' : 'neutral';
  return (
    <div className={`index-row index-row--${tone}`}>
      <div>
        <strong>{name}</strong>
        <small>{symbol}</small>
      </div>
      <div className="index-row__value">
        <span>{formatNumber(quote.last)}</span>
        <small>{formatPercent(quote.changePct)}</small>
      </div>
    </div>
  );
}
